export enum ProjectInfrastructureOwnerEnum {
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  CLIENT = 'CLIENT',
  ORGANIZATION = 'ORGANIZATION',
  COMMUNE = 'COMMUNE',
}
